import React from 'react';
import InvalidFeedback from './invalid-feedback.component';

export default React.forwardRef(
  ({ label, typeText = '', className = '', spacingEnd = '10', errors, ...register }: any, ref) => {
    return (
      <>
        <div
          className={`form-check form-check-custom form-check-solid check-normal ${className} me-${spacingEnd} `}
        >
          <input
            type="checkbox"
            className="form-check-input cursor-pointer"
            ref={ref}
            {...register}
          />
          <label className={`form-check-label ${typeText}`}>{label}</label>
        </div>
        <InvalidFeedback error={errors} />
      </>
    );
  }
);
